import { Home24Filled, Home24Regular } from "@fluentui/react-icons";

import React from "react";
import { TeamAppConfig } from "Apps/TeamAppModel";

const DashboardApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "Dashboard" */ "./DashboardApp");
    return { default: namedExport.DashboardApp };
});

export const Dashboard: TeamAppConfig = {
    title: "Home",
    regularIcon: Home24Regular,
    filledIcon: Home24Filled,
    description: "Home page of M365 Pulse. Home allows users to create views to see their saved widgets as well as others.",
    team: "OSP",
    publicId: "Exchange\\OSP",
    owner: "OspOncall@microsoft.com",
    role: "*",
    tags: [],
    app: DashboardApp,
    path: "/dashboard"
};
